// Dummy placeholder for CSS
export default class TabIndicator {
}
//# sourceMappingURL=index.js.map